/* tslint:disable */
/* eslint-disable */
/**
 * Token.WebApi v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  streetName?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  streetNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  cityName?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  country?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  county?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  postalCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  countryIsoCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  placeName?: string | null;
}

/**
 * Check if a given object implements the AddressDto interface.
 */
export function instanceOfAddressDto(value: object): value is AddressDto {
  return true;
}

export function AddressDtoFromJSON(json: any): AddressDto {
  return AddressDtoFromJSONTyped(json, false);
}

export function AddressDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddressDto {
  if (json == null) {
    return json;
  }
  return {
    streetName: json['streetName'] == null ? undefined : json['streetName'],
    streetNumber:
      json['streetNumber'] == null ? undefined : json['streetNumber'],
    cityName: json['cityName'] == null ? undefined : json['cityName'],
    country: json['country'] == null ? undefined : json['country'],
    county: json['county'] == null ? undefined : json['county'],
    postalCode: json['postalCode'] == null ? undefined : json['postalCode'],
    countryIsoCode:
      json['countryIsoCode'] == null ? undefined : json['countryIsoCode'],
    placeName: json['placeName'] == null ? undefined : json['placeName'],
  };
}

export function AddressDtoToJSON(json: any): AddressDto {
  return AddressDtoToJSONTyped(json, false);
}

export function AddressDtoToJSONTyped(
  value?: AddressDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    streetName: value['streetName'],
    streetNumber: value['streetNumber'],
    cityName: value['cityName'],
    country: value['country'],
    county: value['county'],
    postalCode: value['postalCode'],
    countryIsoCode: value['countryIsoCode'],
    placeName: value['placeName'],
  };
}
